import React from "react";
import Chip from "@mui/material/Chip";

export function chipAprovacaoStatus(status) {
  if (status === "Aprovado") return <Chip label="Aprovado" size="small" sx={{ backgroundColor: "#2e7d32", color: "#fff", fontWeight: "bold" }} />;
  if (status === "Reprovado") return <Chip label="Reprovado" size="small" sx={{ backgroundColor: "#d32f2f", color: "#fff", fontWeight: "bold" }} />;
  if (status === "Aguardando")
    return <Chip label="Enviou para ciclo de aprovação" size="small" sx={{ backgroundColor: "#555", color: "#ccc", fontWeight: "bold" }} />;
  if (status === "EmAnalise") return <Chip label="Em Análise" size="small" sx={{ backgroundColor: "#1998a8", color: "#fff", fontWeight: "bold" }} />;
  if (status === "Respondido") return <Chip label="Respondido" size="small" sx={{ backgroundColor: "#e65100", color: "#fff", fontWeight: "bold" }} />;
  if (status === "AguardandoResposta")
    return <Chip label="Aguard. Resposta" size="small" sx={{ backgroundColor: "#f57f17", color: "#fff", fontWeight: "bold" }} />;
  if (status === "Cancelado") return <Chip label="Cancelado" size="small" sx={{ backgroundColor: "#444", color: "#aaa" }} />;
  if (status === "Revisado") return <Chip label="Pediu Revisão" size="small" sx={{ backgroundColor: "#e65100", color: "#fff", fontWeight: "bold" }} />;
  return <Chip label="—" size="small" sx={{ backgroundColor: "#444", color: "#aaa" }} />;
}
